import { fasShieldKeyhole } from 'shared/@generated/icons/fasShieldKeyhole';
import { View } from 'react-native';
import { Text } from 'shared/components/text';
import { Icon } from 'shared/components/icon';

const PetPayBadge = () => {
  return (
    <View className={'bg-brand-brown-dark flex-row items-center gap-1 rounded-full px-1.5 py-1'}>
      <Icon icon={fasShieldKeyhole} className={'size-3'} color={'#fffbf7'} />
      <Text className={'text-brand-cream-light text-2xs font-black'}>PetPay</Text>
    </View>
  );
};

export { PetPayBadge };
